import { pick } from 'lodash'

type MortgageAndMortgageCalculatedValues = 'monthly_payment' | 'revert_monthly_payment'

export const pickMortgageOrMortgageCalculatedValue = (
  calculatedValuesKey: MortgageAndMortgageCalculatedValues,
  mortgage?: Maybe<Mortgage>,
) => {
  if (!mortgage) return null
  // properties on mortgage
  const mortgageObject = pick(mortgage, calculatedValuesKey)
  // properties on caculated_values
  const calculatedValuesObject = pick(mortgage?.calculated_values, calculatedValuesKey)
  // calculated values should be prioritised
  return calculatedValuesObject[calculatedValuesKey] ?? (mortgageObject[calculatedValuesKey] || null)
}

export const pickMortgageOrMortgageCalculatedValues = (
  calculatedValuesKeys: MortgageAndMortgageCalculatedValues[],
  mortgage?: Maybe<Mortgage>,
) => {
  if (!mortgage) return null
  return calculatedValuesKeys.reduce(
    (
      acc: {
        [key in MortgageAndMortgageCalculatedValues]: string | undefined | null
      },
      mortgageKey: MortgageAndMortgageCalculatedValues,
    ) => {
      return {
        ...acc,
        [mortgageKey]: pickMortgageOrMortgageCalculatedValue(mortgageKey, mortgage),
      }
    },
    {} as {
      [key in MortgageAndMortgageCalculatedValues]: string | undefined | null
    },
  )
}

export const PREFERENCE_MAP: Record<MortgageReason, string> = {
  INVALID_MORTGAGE_REASON: 'productTypes.noReasonProvided',
  REASON_HOUSE_MOVE: 'productTypes.houseMove',
  REASON_REMORTGAGE: 'productTypes.remortgage',
  REASON_BTL: 'productTypes.buyToLet',
  REASON_BTL_REMORTGAGE: 'productTypes.buyToLetRemortgage',
  REASON_FTB: 'productTypes.firstTimeBuy',
  REASON_EQUITY_RELEASE: 'productTypes.equityRelease',
  REASON_FURTHER_ADVANCE: 'productTypes.furtherAdvance',
  REASON_BUSINESS_PROTECTION: 'productTypes.businessProtection',
  REASON_PROTECTION: 'productTypes.protection',
  REASON_COMMERCIAL: 'productTypes.commercial',
  REASON_BRIDGING: 'productTypes.bridging',
  REASON_GENERAL_INSURANCE: 'productTypes.homeInsurance',
}

export const RELATION_MAP: Record<RelatedUserRelationshipType, string> = {
  INVALID_RELATIONSHIP_TYPE: 'generic.notFound',
  REFERRER: 'relationType.referrer',
  ADMINISTRATOR: 'relationType.administrator',
  LEAD_QUALIFIER: 'relationType.leadQualifier',
  CASE_MANAGER: 'relationType.caseManager',
  WATCHER: 'relationType.watcher',
  REVIEWER: 'relationType.reviewer',
}
